export const assignJobReturnSidebarText = {
	panelHeader: 'Select a driver to assign',
	errorMessage: "Can't fetch data, try again.",
	searchLabel: 'Filter employees',
	searchPlaceholder: 'e.g. John Smith',
	searchInfo: 'The search includes all crew members in the system.',
	perfectFit: 'Perfect fit:',
	noCrewMembersFound: 'No crew members found.',
	noEligibleCrewMembers: 'No eligible crew members found.',
	returnJobAction: 'Click to add the return job',
	warningTitle: 'Driver eligibility warning',
	warningDescription:
		'You are attempting to assign a driver who does not meet the required eligibility rules for this segment :',
	warningDisclaimer:
		'Proceeding with this action is at your own risk and may result in operational issues or non-compliance.',
	cancelButton: 'Cancel',
	assignAnywayButton: 'Assign anyway',
	delayTooSmall: 'The entered delay is too small.',
	delayTooLarge: 'The entered delay is too large.',
};
